import { render, staticRenderFns } from "./accountDetail.vue?vue&type=template&id=d5579bbe&scoped=true"
import script from "./accountDetail.vue?vue&type=script&lang=js"
export * from "./accountDetail.vue?vue&type=script&lang=js"
import style0 from "./accountDetail.vue?vue&type=style&index=0&id=d5579bbe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5579bbe",
  null
  
)

export default component.exports